export default __webpack_public_path__ + "static/media/learn-card-1.fb15cdb9.png";